module.exports = __webpack_public_path__ + "static/media/Common Amenities.a2104333.svg";